function Container({ children }) {
  return (
    <div className="flex flex-col flex-1 h-full overflow-hidden w-full min-w-0">
      {children}
    </div>
  )
}

export default Container;